export default __webpack_public_path__ + "static/media/passport-error-image.1df80e7a.svg";